"use client";

import { Provider } from "react-redux";
import { store } from "./store";
import HydrationWrapper from "./HydrationWrapper";

export default function ReduxProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Provider store={store}>
      <HydrationWrapper>{children}</HydrationWrapper>
    </Provider>
  );
}
